import { GET_OFFER_SCHEME_LIST_API_URL } from "../components/Shared/constant";

const GetOfferSchemeListAPI = async (params, accessToken) => {
  const response = window.axios
    .get(GET_OFFER_SCHEME_LIST_API_URL, {
      params,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + accessToken,
      },
    })
    .then(function (result) {
      return {
        data: {
          data: result.data.data.data,
          pagination: result.data.data.pagination,
        },
        status: 200,
      };
    })
    .catch(function (result) {
      return {
        ...result?.response?.data,
        status: result?.response?.status,
      };
    });
  return response;
};

export default GetOfferSchemeListAPI;
